<template>
<body style="background-color:#D6D6D6">
    <div id="planeacionesOnu">
        <v-container>
            <!--<h1 class="pl-5 ml-4 pt-5" style="color:#942C75; font-family:Poppins; font-size:1.8vw; font-weight:500">{{title}}</h1>-->
            <!--<v-layout justify-center>
            <img class="hidden-xs-only" src="3K.png">
            <img class="hidden-sm-and-up" src="3K.png" width="300px" height="79px">
            </v-layout> -->
            <ContentRead portada="portada-onu.jpeg" :files="planeacionesONU">
            </ContentRead>
            <!--<br><br><br><br><br><br><br>-->
       </v-container>
         

    </div>
    </body>
</template>


<script>
import ContentRead from "@/components/ContentRead.vue"

export default {
   
    components:{
       ContentRead
     },

    data(){
        return{
            title:"PLANEACIONES ONU",
            planeacionesONU:[
          
          {title:"Dia de la alimentacion",img:"blanco.png",url:"../descargas/files/planeaciones/onu/dia_de_la_alimentacion.pdf",namedownload:"dia_de_la_alimentacion"},
          {title:"Dia de la discapacidad",img:"blanco.png",url:"../descargas/files/planeaciones/onu/dia_de_la_discapacidad.pdf",namedownload:"dia_de_la_discapacidad"},
          {title:"Dia de la limpieza",img:"blanco.png",url:"../descargas/files/planeaciones/onu/dia_de_la_limpieza.pdf",namedownload:"dia_de_la_limpieza"},
          {title:"Dia de la musica",img:"blanco.png",url:"../descargas/files/planeaciones/onu/dia_de_la_musica.pdf",namedownload:"dia_de_la_musica"},
          {title:"Dia de la ONU",img:"blanco.png",url:"../descargas/files/planeaciones/onu/dia_de_la_onu.pdf",namedownload:"dia_de_la_onu"},
          {title:"Dia de la paz",img:"blanco.png",url:"../descargas/files/planeaciones/onu/dia_de_la_paz.pdf",namedownload:"dia_de_la_paz"},
          {title:"Dia de la solidaridad",img:"blanco.png",url:"../descargas/files/planeaciones/onu/dia_de_la_solidaridad.pdf",namedownload:"dia_de_la_solidaridad"},
          {title:"Dia de la tolerancia",img:"blanco.png",url:"../descargas/files/planeaciones/onu/dia_de_la_tolerancia.pdf",namedownload:"dia_de_la_tolerancia"},
          {title:"Dia de la cruz roja",img:"blanco.png",url:"../descargas/files/planeaciones/onu/dia_de_la_cruz_roja.pdf",namedownload:"dia_de_la_cruz_roja"},
          {title:"Dia de la danza",img:"blanco.png",url:"../descargas/files/planeaciones/onu/dia_de_la_danza.pdf",namedownload:"dia_de_la_danza"},
          {title:"Dia de las familias",img:"blanco.png",url:"../descargas/files/planeaciones/onu/dia_de_las_familias.pdf",namedownload:"dia_de_las_familias"},
          {title:"Dia del maestro",img:"blanco.png",url:"../descargas/files/planeaciones/onu/dia_del_maestro.pdf",namedownload:"dia_del_maestro"},
        ]
        }
    }
}
</script>

<style scoped>

</style>


